/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import MyContext from "../../components/Mycontext";

// import logo from "../../../static/logo.png";
import openboxIcon from "../../../static/icon/openbox.svg";
import lightOpenboxIcon from "../../../static/light-icon/lightopenbox.svg";
import Settings from "../../../static/icon/Settings.svg";
import lightSettings from "../../../static/light-icon/Settings.svg";
import ShowBalanceModal from "../../ShowBalanceModal";
import {Dropdown, Image} from "react-bootstrap";
import {Avatar, Button, message} from "antd";

import {getUserApi,} from "../../../api/Api";
import {useNavigate} from "react-router-dom";
import {TASK_TYPE, TaskType} from "../../../config";
import ModelDropdown from "../../DoctaAiTest/components/ModelDropdown";
import {useAuth} from "../../../providers/AuthProvider";
import {useTranslation} from "react-i18next";
import {useTheme} from "../../../providers/CustomThemeProvider";
import {MoonOutlined, SunOutlined} from "@ant-design/icons";
import {copyToClipboard} from "../../DoctaAiTest/utils";
import InfoPanel from "../InfoPanel";

function Headers(props: any) {
	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const {
		selectedChat,
		conversationId,
		setSelectedChat,
		setIsInputValue,
		setConversationId,
		isLoad,
		isInputValue,
		sessionId,
		file,
		setFile,
		fileUrl,
		setFileUrl,
		requireType,

		addSession,
		hideSide,
		setHideSide,
		recordList,
		setRecordList,
		needFresh,
		setNeedFresh,
		getConversationList,
	} = context;
	const { isDarkMode, switchTheme } = useTheme();

	const typeMap = [
		TASK_TYPE.LANGUAGE_SAFETY,
		TASK_TYPE.QUERY_DATA,
		TASK_TYPE.CHECK_LABEL,
		TASK_TYPE.LOW_QUALITY_DETECTION,
	];
	const { setUserInfo } = useAuth();
	const userdetail = useAuth();
	const user = userdetail?.userInfo;

	const [taskType, setTaskType] = useState<TaskType>(
		typeMap[selectedChat?.type ?? 1]
	);

	useEffect(() => {
		console.log("=========selectedChat ", sessionId, selectedChat);
		setTaskType(typeMap[selectedChat?.type ?? 1]);
		// if (conversationId !== 0) {
		// 	setTaskType(typeMap[selectedChat?.type ?? 0]);
		// }
	}, [selectedChat]);

	const [show, setShow] = useState(false);
	const [showBalance, setShowBalance] = useState(false);

	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const refreshCallback = () => {
		// seleConversation(selectedChat?.id ?? conversationId);
		getConversationList(selectedChat?.id ?? conversationId);
	};

	useEffect(() => {
		if (needFresh) {
			refreshCallback();
			setNeedFresh(false);
		}
	}, [needFresh]);
	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
				userdetail.setUserInfo(res);
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e.message);
			});
	};

	const LogOut = () => {
		localStorage.removeItem("user");
		localStorage.removeItem("token");
		localStorage.removeItem("selectedChat");
		localStorage.removeItem("conversationId");
		sessionStorage.removeItem("sessionId");
		navigate("/");
	};


	return (
		<>
			<div className="docta-ai-head">

				<InfoPanel
					show={show}
					setShow={setShow}
					isDarkMode={isDarkMode}
					user={user}
					copyToClipboard={copyToClipboard}
					message={message}
				/>
				{hideSide && (
					<div
						className="hideside-icon"
						onClick={() => {
							setHideSide(!hideSide);
						}}
					>
						<Image src={isDarkMode ? openboxIcon : lightOpenboxIcon} />
					</div>
				)}
				{selectedChat?.id && (
					<>
						<ModelDropdown
							taskType={taskType}
							onClickItem={(item: any) => {
								setTaskType(item);
								addSession(false, item);
							}}
						/>
						<Button disabled size="small" style={{ color: "grey" }}>
							{requireType}
						</Button>
					</>
				)}

				<Image
					src={isDarkMode ? Settings : lightSettings}
					className="docta-ai-settings"
					onClick={() => {
						setShow(true);
					}}
				/>
				<Avatar
					size={"small"}
					style={{
						marginRight: 10,
						backgroundColor: !isDarkMode ? "#6D8DFF" : "lightgrey",
					}}
					onClick={switchTheme}
					icon={isDarkMode ? <MoonOutlined /> : <SunOutlined />}
				/>

				{user?.role === "ROLE_ADMIN" && (
					<Avatar
						size={"small"}
						style={{
							marginRight: 5,
							cursor: "pointer",
							backgroundColor: !isDarkMode ? "#6D8DFF" : "lightgrey",
						}}
						onClick={() => {
							i18n.language == "en"
								? i18n.changeLanguage("zh")
								: i18n.changeLanguage("en");
						}}
					>
						{i18n.language == "en" ? "EN" : "中"}
					</Avatar>
				)}
				<Dropdown className="d-inline mx-2" align={{ lg: "end" }}>
					<Dropdown.Toggle id="dropdown-autoclose-true">
						<Avatar
							size={"small"}
							style={{ backgroundColor: "lightblue", padding: 12 }}
						>
							{user?.name?.[0]}
						</Avatar>
					</Dropdown.Toggle>

					<Dropdown.Menu className="docta-ai-user-dropdown">
						<Dropdown.Item
							onClick={() => {
								LogOut();
							}}
						>
							{t("op.logout")}
						</Dropdown.Item>
						<Dropdown.Item
							onClick={() => {
								navigate("/plans");
							}}
						>
							{t("op.member")}
						</Dropdown.Item>
						<Dropdown.Item
							onClick={() => {
								setShowBalance(true);
							}}
						>
							{t("op.balance")}
						</Dropdown.Item>
						{i18n.language == "en" && (
							<Dropdown.Item href={process.env.REACT_APP_STRIPE_URL}>
								{t("op.reload")}
							</Dropdown.Item>
						)}
					</Dropdown.Menu>
				</Dropdown>
			</div>

			<ShowBalanceModal
				show={showBalance}
				onHide={() => {
					setShowBalance(false);
				}}
			/>
		</>
	);
}

export default Headers;
